//export const baseApiUrl = 'http://localhost:55762/api';
export const baseApiUrl = 'https://api.its-qa.com/rebook/api';
export const siteUrl = 'rebook.its-qa.com';
export const cdnUrl = 'http://cdn2.its.com/Content/';
export const newApiUrl = 'https://lnoc7lcxxb.execute-api.us-east-1.amazonaws.com/prod';
export const weatherServiceUrl = 'https://www.weatherbug.com/weather-forecast/now/';
export const openTablesServiceUrl = 'https://www.opentable.com/s?term=';

export const contactAgentEMail = 'support@tripeasy.com';
export const contactAgentTel = '855-301-8472';
export const GOOGLE_PACKAGE_NAME = 'com.TripEasyCorpTravel';
export const APPLE_STORE_ID = 'id284882215';
export const TRIPHUB_ENABLED = false;
export const REBOOK_ENABLED = true;
export const AA_ENABLED = false;
export const TRIPEVENTS_ENABLED = false;
export const EVENTS_ENABLED = false;
export const EXPENSEPOINT_ENABLED = false;
export const TERMS_URL = 'https://rebook.tripeasy.com/web/termsconditions';
export const PRIVACY_URL = 'https://rebook.tripeasy.com/web/privacypolicy';
